"use strict";
var addRow = document.querySelector(".append-row");
var removeRow = document.querySelector(".remove-row");
var addColumn = document.querySelector(".append-column");
var removeColumn = document.querySelector(".remove-column");
var tableRow = document.querySelector(".field tr");
var tbody = document.querySelector("tbody");
var minElements = 2;
var maxElements = 10;
addRow.addEventListener("click", function() {
    var count = tbody.childElementCount;
    if (count === maxElements - 1) addRow.setAttribute("disabled", "");
    if (count < maxElements) {
        if (removeRow.hasAttribute("disabled")) removeRow.removeAttribute("disabled");
        tableRow.parentNode.append(createRow());
    }
});
removeRow.addEventListener("click", function() {
    var count = tbody.childElementCount;
    if (count === minElements + 1) removeRow.setAttribute("disabled", "");
    if (count > minElements) {
        if (addRow.hasAttribute("disabled")) addRow.removeAttribute("disabled");
        tbody.lastElementChild.remove();
    }
});
addColumn.addEventListener("click", function() {
    var tr = document.querySelectorAll(".field tr");
    tr.forEach(function(element) {
        var count = element.cells.length;
        if (count === maxElements - 1) addColumn.setAttribute("disabled", "");
        if (count < maxElements) {
            if (removeColumn.hasAttribute("disabled")) removeColumn.removeAttribute("disabled");
            element.lastElementChild.after(createColumn());
        }
    });
});
removeColumn.addEventListener("click", function() {
    var tr = document.querySelectorAll(".field tr");
    tr.forEach(function(element) {
        var count = element.cells.length;
        if (count === minElements + 1) removeColumn.setAttribute("disabled", "");
        if (count > minElements) {
            if (addColumn.hasAttribute("disabled")) addColumn.removeAttribute("disabled");
            element.lastElementChild.remove();
        }
    });
});
function createRow() {
    var row = document.createElement("tr");
    for(var i = 0; i < tableRow.cells.length; i++){
        var column = document.createElement("td");
        row.append(column);
    }
    return row;
}
function createColumn() {
    var column = document.createElement("td");
    return column;
}

//# sourceMappingURL=index.953f18d5.js.map
